module.exports = __webpack_public_path__ + "img/ico-down.2bb6ee1d.svg";